import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import { compose } from 'recompose';
import { Button, Segment, Table, Input, Select, Popup, Divider } from 'semantic-ui-react';
import EditButton from './edit-button';
import { reportError } from '../../utils/error-handling-service';
import countries from '../../utils/helpers/countries';
import hasUserInfo from '../../hocs/has-user-info';
import { fetchOrganizationEmails, validateEmail } from '../../utils/influencer-email';
import hasJSONAPIClient from '../../hocs/has-jsonapi-client';

const errorStyle = {
  color: '#9f3a38',
  fontSize: 12,
};

const dividerStyle = {
  margin: '5px 0',
};


class ProfileContactDetails extends Component {
  static propTypes = {
    influencer: PropTypes.object.isRequired,
    onInfluencerPatch: PropTypes.func.isRequired,
    afterUpdate: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      editing: false,
      loading: false,
      name: props.influencer.name,
      dob: props.influencer.dob,
      sweatcoin: props.influencer.sweatcoin,
      email: props.influencer.email,
      emailValid: true,
      contactNumber: props.influencer.contactNumber,
      addressLine1: props.influencer.addressLine1,
      city: props.influencer.city,
      region: props.influencer.region,
      postalCode: props.influencer.postalCode,
      country: props.influencer.country,
      agentName: props.influencer.agentName,
      agentEmail: props.influencer.agentEmail,
      agentContactNumber: props.influencer.agentContactNumber,
    };
  }

  onEditClicked = () => {
    const { organisationEmails } = this.state;
    const { userInfo, jsonAPIClient } = this.props;
    this.setState({ editing: true });
    if (_.isEmpty(organisationEmails)) {
      this.setState({ loading: true });
      fetchOrganizationEmails({
        userInfo,
        jsonAPIClient,
      })
        .then(emails => this.setState({
          organisationEmails: emails,
          loading: false,
        }, this.validateInfluencerEmail))
        .catch(e => {
          reportError('INFLUENCER_FETCH_ERROR', e);
        });
    }
  }

  validateInfluencerEmail = _.debounce(() => {
    const { email, organisationEmails } = this.state;
    const { userInfo, jsonAPIClient } = this.props;
    const influencerId = this.props.influencer.id;
    this.setState({
      emailValidating: true,
    });
    validateEmail({
      value: email,
      organisationEmails,
      userInfo,
      jsonAPIClient,
      influencerId,
    }).then(({ isValid, message }) => this.setState({
      emailValid: isValid,
      emailMessage: message,
      emailValidating: false,
    }))
      .catch(e => {
        console.error(e);
        reportError('EMAIL_VALIDATION_ERROR', e);
      });
  }, 300)


  handleEmailChange = (e, { name, value }) => {
    this.handleChange(e, { name, value });
    this.setState({
      emailValidating: true,
    });
    this.validateInfluencerEmail();
  }


  processUpdate = () => {
    const influencerID = this.props.influencer.id;

    const {
      name,
      dob,
      sweatcoin,
      email,
      contactNumber,
      addressLine1,
      city,
      region,
      postalCode,
      country,
      agentName,
      agentEmail,
      agentContactNumber,
    } = this.state;

    const patch = {
      name,
      dob,
      sweatcoin,
      email,
      contactNumber,
      addressLine1,
      city,
      region,
      postalCode,
      country,
      agentName,
      agentEmail,
      agentContactNumber,
    };

    const patchParams = _.pickBy(patch);

    console.log(patchParams);

    const trimmedPatch = _.fromPairs(_.map(patchParams, (value, key) => [key, _.trim(value)]));
    this.props.onInfluencerPatch(influencerID, trimmedPatch);

    this.setState({
      editing: false,
    }, this.props.afterUpdate);
  }

  handleChange = (e, v) => this.setState({ [v.name]: v.value });

  reset = () => this.setState({
    editing: false,
    name: this.props.influencer.name,
    dob: this.props.influencer.dob,
    sweatcoin: this.props.influencer.sweatcoin,
    email: this.props.influencer.email,
    emailMessage: null,
    emailValid: true,
    emailValidating: false,
    contactNumber: this.props.influencer.contactNumber,
    addressLine1: this.props.influencer.addressLine1,
    city: this.props.influencer.city,
    region: this.props.influencer.region,
    postalCode: this.props.influencer.postalCode,
    country: this.props.influencer.country,
    agentName: this.props.influencer.agentName,
    agentEmail: this.props.influencer.agentEmail,
    agentContactNumber: this.props.influencer.agentContactNumber,
  });

  render() {
    const status = this.props.influencer.status;
    const isClaimed = status === 'CLAIMED';
    const {
      name,
      dob,
      sweatcoin,
      email,
      editing,
      contactNumber,
      addressLine1,
      city,
      region,
      postalCode,
      country,
      agentName,
      agentEmail,
      agentContactNumber,
      loading,
      emailValid,
      emailValidating,
      emailMessage,
    } = this.state;

    const dobDisplay = dob ? `${moment(dob).format('DD/MM/Y')} -- (age ${moment().diff(dob, 'years')})`
      : '-';

    return (
      <Segment padded>
        <h3>Contact Details</h3>
        <Table basic="very">
          <Table.Body>
            <Table.Row>
              <Table.Cell collapsing>
                <p>Name</p>
              </Table.Cell>
              <Table.Cell>
                <Input name="name" value={name} onChange={this.handleChange} fluid readOnly={!editing} />
              </Table.Cell>
            </Table.Row>
            {sweatcoin && <Table.Row>
              <Table.Cell collapsing>
                <p>Sweatcoin username</p>
              </Table.Cell>
              <Table.Cell>
                <Input
                  name="sweatcoin"
                  readOnly={!editing}
                  value={sweatcoin}
                  onChange={this.handleChange}
                  fluid
                />
              </Table.Cell>
            </Table.Row>}
            <Table.Row>
              <Table.Cell collapsing>
                <p>D.O.B.</p>
              </Table.Cell>
              <Table.Cell>
                { !editing && <Input name="name" value={dobDisplay} fluid readOnly />}
                { editing && <Input
                  width={16}
                  label="D.O.B"
                  placeholder="e.g. 01/05/2000"
                  name="dob"
                  onChange={this.handleChange}
                  value={dob}
                  type="date"
                /> }
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>
                <p>Email address</p>
              </Table.Cell>
              <Table.Cell>
                <Popup
                  position="right center"
                  open={!emailValid} trigger={
                    <Input
                      readOnly={!editing}
                      hasLabel={false}
                      fluid
                      value={email}
                      error={!emailValid}
                      loading={emailValidating}
                      name="email"
                      onBlur={this.validateInfluencerEmail}
                      onChange={this.handleEmailChange}
                    />
                  }
                  content={
                    <div style={errorStyle}>
                      <h3>Invalid e-mail</h3>
                      <Divider fitted style={dividerStyle} />
                      { emailMessage }
                    </div>
                  }
                />
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>
                <p>Contact Number</p>
              </Table.Cell>
              <Table.Cell>
                <Input
                  name="contactNumber"
                  readOnly={!editing}
                  value={contactNumber}
                  onChange={this.handleChange}
                  fluid
                />
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell verticalAlign="top" collapsing>
                <p>Address</p>
              </Table.Cell>
              <Table.Cell>
                <Input
                  fluid
                  name="addressLine1"
                  readOnly={!editing}
                  value={addressLine1}
                  placeholder="Address Line One"
                  onChange={this.handleChange}
                />
                <div className="spacer small" />
                <Input
                  name="city"
                  readOnly={!editing}
                  value={city}
                  placeholder="City"
                  onChange={this.handleChange}
                  fluid
                />
                <div className="spacer small" />
                <Input
                  name="region"
                  readOnly={!editing}
                  value={region}
                  placeholder="Region"
                  onChange={this.handleChange}
                  fluid
                />
                <div className="spacer small" />
                <Input
                  name="postalCode"
                  readOnly={!editing}
                  value={postalCode}
                  placeholder="Post Code"
                  onChange={this.handleChange}
                  fluid
                />
                <div className="spacer small" />
                <Select
                  fluid
                  name="country"
                  value={country}
                  options={countries}
                  onChange={this.handleChange}
                  required
                  disabled={!editing}
                />
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>
                <p>Agent Name</p>
              </Table.Cell>
              <Table.Cell>
                <Input name="agentName" readOnly={!editing} value={agentName} onChange={this.handleChange} fluid />
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>
                <p>Agent Email</p>
              </Table.Cell>
              <Table.Cell>
                <Input name="agentEmail" readOnly={!editing} value={agentEmail} onChange={this.handleChange} fluid />
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>
                <p>Agent Contact Number</p>
              </Table.Cell>
              <Table.Cell>
                <Input
                  fluid
                  name="agentContactNumber"
                  readOnly={!editing}
                  value={agentContactNumber}
                  onChange={this.handleChange}
                />
              </Table.Cell>
            </Table.Row>
            {editing
              ? <Table.Row>
                <Table.Cell>
                  <div className="spacer small" />
                  <Button size="medium" basic fluid onClick={this.reset}>Cancel</Button>
                </Table.Cell>
                <Table.Cell>
                  <div className="spacer small" />
                  <Button
                    size="medium"
                    fluid
                    color="pink"
                    disabled={loading || !emailValid || emailValidating}
                    loading={loading || emailValidating}
                    onClick={this.processUpdate}
                  >
                      Save Changes
                  </Button>
                </Table.Cell>
              </Table.Row>
              : <Table.Row>
                <Table.Cell colSpan={2}>
                  <div className="spacer small" />
                  <EditButton
                    isClaimed={isClaimed}
                    content="Edit Contact Details"
                    onClick={this.onEditClicked}
                  />
                </Table.Cell>
              </Table.Row>}
          </Table.Body>
        </Table>
      </Segment>
    );
  }
}

export default compose(
  hasUserInfo,
  hasJSONAPIClient,
)(ProfileContactDetails);



/** WEBPACK FOOTER **
 ** ./src/containers/influencer-profile/profile-contact-details.js
 **/